import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { Box } from '@atlaskit/primitives';
import { messages } from '../../../../../../messages';
import AIIconLoading from '../../../../../common/ai-icon-loading';
import AIIndicatorContainer from './ai-indicator-container';
var AIStateLoading = function AIStateLoading(_ref) {
  var appearance = _ref.appearance,
    testId = _ref.testId;
  var icon = /*#__PURE__*/React.createElement(AIIconLoading, {
    label: "AI",
    size: "small",
    testId: "".concat(testId, "-loading-icon")
  });
  switch (appearance) {
    case 'icon-only':
      return icon;
    default:
      return /*#__PURE__*/React.createElement(AIIndicatorContainer, {
        icon: icon,
        content: /*#__PURE__*/React.createElement(Box, {
          testId: "".concat(testId, "-loading-message")
        }, /*#__PURE__*/React.createElement(FormattedMessage, messages.ai_summarizing)),
        testId: "".concat(testId, "-loading")
      });
  }
};
export default AIStateLoading;